import { addDays, subDays, subMonths, addMonths, subWeeks, addWeeks, CalandarService, CommonAction } from '@/imports-files/components/calendar/calendar';


export class CalendarAction
{
    constructor(setCalendarData, calendarHash, router, setCalendarDataArray)
    {
        this.calandatService = new CalandarService();
        this.setCalendarData = setCalendarData;
        this.calendarHash = calendarHash;
        this.commonAction = new CommonAction();
        this.router = router;
        this.setCalendarDataArray = setCalendarDataArray
    }

    getCalanderData(calendarHash)
  	{
      var body 	     =  {activities: calendarHash};
      body.activities.current_date = this.commonAction.getDateInString(body.activities.current_date);
  		var k_this 		 =  this;
    	this.calandatService.getEventData(body).then(result => {
                                  	let calendar_array = result.data.data.events.data;
                                    let calendar_data_array = result.data.data.events.date_range_array;
  																	k_this.setCalendarData(calendar_array);
                                                                    k_this.setCalendarDataArray(calendar_data_array)

  																});
  	}

    setTodayDate(setTodayClick)
    {
        // We are just changing the state of the page which rerender the component
        // and set the selected date
        this.calendarHash.current_date     = this.commonAction.getDateInDMYFormat(new Date());
        this.calendarHash.selected_tab     = this.commonAction.getParamsToUrlWithoutRouter('selected_tab');
        this.calendarHash.is_my_interviews = this.commonAction.getParamsToUrlWithoutRouter('is_my_interviews');
        this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
        setTodayClick(true);
        document.querySelector('.react-tabs__today').classList.add('react-tabs__tab--selected');
        return Math.random()*1000;
    }

    setTabIndex()
    {
        let selected_tab = this.router.query.selected_tab
        switch(selected_tab)
        {
          case 'day':return 0;
          case 'week':return 1;
          case 'month':return 2;
          default: return 2;
        }
    }


    changeDateHandle(btnType, currentDate, setCurrentDate, setTodayClick)
    {
        if(btnType === "prev"){
            setCurrentDate(subDays(currentDate, 1));
            this.calendarHash.current_date = subDays(currentDate, 1).toLocaleDateString();;
            this.getCalanderData(this.calendarHash);
            setTodayClick(false);
            this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
        }
        if(btnType === "next"){
            setCurrentDate(addDays(currentDate, 1));
            this.calendarHash.current_date = addDays(currentDate, 1).toLocaleDateString();;
            this.getCalanderData(this.calendarHash);
            setTodayClick(false);
            this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
        }
    }



    //------------------- MONTH ----------------
    changeMonthHandle(btnType, currentMonth, setCurrentMonth){
       if (btnType === 'prev'){
            setCurrentMonth(subMonths(currentMonth, 1));
        }
        if (btnType === 'next'){
            setCurrentMonth(addMonths(currentMonth, 1));
        }
    }

    onMonthDateClickHandle(day, dayStr, setSelectedDate, setTodayClick){
        setSelectedDate(day);
        this.calendarHash.current_date = this.commonAction.getDateInDMYFormat(day);
        this.getCalanderData(this.calendarHash);
        setTodayClick(false);
        this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
        // showDetailsHandle(dayStr);
    }
    //------------------- MONTH ----------------


    //------------------- WEEK ----------------
    changeWeekHandle(btnType, currentWeek, setCurrentWeek)
    {
        if(btnType === "prev"){
            setCurrentWeek(subWeeks(currentWeek, 1));
        }
        if(btnType === "next"){
            setCurrentWeek(addWeeks(currentWeek, 1));
        }
    }

    onWeekDateClickHandle(day, dayStr, setSelectedDate, setTodayClick)
    {
        setSelectedDate(day);
        this.calendarHash.current_date = this.commonAction.getDateInDMYFormat(day);
        this.getCalanderData(this.calendarHash);
        setTodayClick(false);
        this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
        // showDetailsHandle1(dayStr);
    }
    //------------------- WEEK ----------------

    onArrowClickHandle(day, dayStr, setTodayClick)
    {
        this.calendarHash.calendar_date = this.commonAction.getDateInDMYFormat(day);
        this.getCalanderData(this.calendarHash);
        setTodayClick(false);
        this.commonAction.paramsToUrlWithoutRouter(this.calendarHash, this.router);
    }

    greenDotClass(date, dateArray, klass){
        date = this.appendZero(date)
        return (dateArray.indexOf(date) != -1) ? klass : ''
    }

    appendZero(str){
      let date = str.split('/')[0]
      return date.length >= 2 ? str : "0"+str
    }

}
